module.exports = __webpack_public_path__ + "img/logo.483dbcb1.svg";